import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const DoubleBookingDialog = ({ isOpen, responseAction }) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={isOpen}
            onClose={() => responseAction(false)}
        >
            <DialogTitle>{t('DoubleBookingDetected')}</DialogTitle>
            <DialogContent>{t('DoYouWantToProceed')}</DialogContent>
            <DialogActions style={{ justifyContent: 'space-between' }}>
                <Button
                    onClick={() => responseAction(false)}
                    style={{ textTransform: 'none' }}
                >
                    {t('NoCancel')}
                </Button>
                <Button
                    onClick={() => responseAction(true)}
                    style={{ textTransform: 'none' }}
                >
                    {t('YesBookAnyway')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DoubleBookingDialog;
